module.exports = __webpack_public_path__ + "static/project.7755ea3d.svg";